<template>
  <v-container fill-height class="mb-5 pa-0 callDetail">
    <v-layout wrap>
      <v-flex xs12 sm12>
        <v-toolbar flat :color="callBG(callDetail.status).header">
          <v-tooltip bottom>
            <v-btn icon @click="$router.go(-1)" slot="activator">
              <v-icon color="white">arrow_back</v-icon>
            </v-btn>

            <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
          </v-tooltip>

          <v-toolbar-title>
            {{ $vuetify.t('$vuetify.calls.callRef') }}:
            {{ callDetail.call_remote_id }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-menu bottom left>
            <v-btn slot="activator" dark icon>
              <v-icon>apps</v-icon>
            </v-btn>

            <v-list>
              <v-list-tile
                @click="acceptCall(callDetail.id)"
                v-if="callDetail.status == 'Available'"
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.acceptCall')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                @click="travelCall(callDetail.id)"
                v-if="callDetail.status == 'Accepted' && !userHasActiveCall"
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.startTravel')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                @click="checkProximity(callDetail.id)"
                v-if="callDetail.status == 'Travelling'"
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.markArrival')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                @click="arrivalProcessBegin()"
                v-if="callDetail.status == 'Arrived'"
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.arrivalComplete')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                :to="{ name: 'callComplete', params: { id: callDetail.id } }"
                v-if="
                  callDetail.status == 'Arrival Completed' ||
                    callDetail.status == 'Departed'
                "
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.completeCall')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                :to="{ name: 'media', params: { id: callDetail.id } }"
                v-if="
                  callDetail.status == 'Arrival Completed' ||
                    callDetail.status == 'Departed'
                "
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.media')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                :to="{ name: 'scans', params: { id: callDetail.id } }"
                v-if="
                  callDetail.status == 'Arrival Completed' ||
                    callDetail.status == 'Departed'
                "
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.scans')
                }}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                @click="dialog = true"
                v-if="callDetail.status != 'Available'"
                id="resetCallButton"
              >
                <v-list-tile-title>{{
                  $vuetify.t('$vuetify.calls.resetCall')
                }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>

        <v-expansion-panel popout expand v-model="panel">
          <v-expansion-panel-content>
            <div slot="header">
              {{ $vuetify.t('$vuetify.calls.callInfo') }}
              <v-chip
                small
                label
                :color="callBG(callDetail.status).header"
                id="statusChip"
              >
                {{ callDetail.status }}
              </v-chip>
            </div>

            <v-card>
              <v-card-text>
                <strong>{{ $vuetify.t('$vuetify.calls.callProblem') }}:</strong>
                <br />
                {{ callDetail.description }}
              </v-card-text>
              <v-card-text v-if="callDetail.office_comment">
                <strong
                  >{{ $vuetify.t('$vuetify.calls.scheduledNote') }}:</strong
                >
                <br />
                {{ callDetail.office_comment }}
              </v-card-text>
              <v-card-text>
                <template v-if="callDetail.scheduled_at">
                  <strong
                    >{{ $vuetify.t('$vuetify.calls.scheduledAt') }}:
                  </strong>
                  {{ formatDatetimeWithoutTimeZone(callDetail.scheduled_at) }}
                  <br />
                </template>
                <template>
                  <strong
                    >{{
                      $vuetify.t('$vuetify.calls.estimatedDuration')
                    }}:</strong
                  >
                  {{ estimatedDuration }}<br />
                </template>
              </v-card-text>
              <v-card-text v-if="callDetail.contract_note">
                <strong
                  >{{ $vuetify.t('$vuetify.calls.contractNote') }}:
                </strong>
                <br />
                {{ callDetail.contract_note }}
              </v-card-text>
              <v-card-text>
                <template v-if="callDetail.remote_id">
                  <strong
                    >{{ $vuetify.t('$vuetify.calls.orderNumber') }}:
                  </strong>
                  {{ callDetail.order_number }}
                  <br />
                </template>
                <template v-if="callDetail.call_type">
                  <strong>{{ $vuetify.t('$vuetify.calls.callType') }}: </strong>
                  {{ callDetail.call_type }}
                  <br />
                </template>
                <template v-if="callDetail.remote_id">
                  <strong>{{ $vuetify.t('$vuetify.calls.eventId') }}: </strong>
                  {{ callDetail.remote_id }}
                  <br />
                </template>
              </v-card-text>
              <v-card-text>
                <strong>{{ $vuetify.t('$vuetify.app.location') }}:</strong>
                <template v-if="callDetail.company">
                  <br />
                  <span>{{ callDetail.company }}</span>
                </template>
                <template v-if="callDetail.address_line_1">
                  <br />
                  <span>{{ callDetail.address_line_1 }}</span>
                </template>
                <template v-if="callDetail.address_line_2">
                  <br />
                  <span>{{ callDetail.address_line_2 }}</span>
                </template>
                <template v-if="callDetail.address_line_3">
                  <br />
                  <span>{{ callDetail.address_line_3 }}</span>
                </template>
                <template v-if="callDetail.city">
                  <br />
                  <span v-if="callDetail.city">{{ callDetail.city }}</span>
                </template>
                <template v-if="callDetail.county">
                  <br />
                  <span v-if="callDetail.county">{{ callDetail.county }}</span>
                </template>
                <template v-if="callDetail.postcode">
                  <br />
                  <span>{{ callDetail.postcode }}</span>
                </template>
                <template v-if="callDetail.company_alias">
                  <br />
                  <strong
                    >{{ $vuetify.t('$vuetify.calls.companyAlias') }}:
                  </strong>
                  <span>{{ callDetail.company_alias }}</span>
                </template>
                <template v-if="callDetail.telephone">
                  <br />
                  <strong
                    >{{ $vuetify.t('$vuetify.calls.telephone') }}:
                  </strong>
                  <a :href="'tel:' + callDetail.telephone">{{
                    callDetail.telephone
                  }}</a>
                  <br />
                </template>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
            <div slot="header">
              {{ $vuetify.t('$vuetify.calls.callTimes') }}
            </div>
            <v-card>
              <v-card-text>
                <v-flex xs12 sm6 md4 lg3>
                  <v-list dense>
                    <v-list-tile v-for="t in timestamps" :key="t.label">
                      <v-list-tile-content
                        ><strong>{{ t.label }}</strong></v-list-tile-content
                      >
                      <v-list-tile-content class="align-end">{{
                        formatDatetimeWithoutTimeZone(t.value)
                      }}</v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
            <div slot="header">
              {{ $vuetify.t('$vuetify.calls.callHistory') }}
            </div>
            <v-card v-if="callDetail.history">
              <div
                v-for="(item, index) in callDetail.history.data"
                :key="item.id"
              >
                <v-card-text v-if="item.to == 'Available' && index > 1">
                  {{ formatDatetimeWithoutTimeZone(item.created_at) }}
                  {{ $vuetify.t('$vuetify.calls.reset') }}
                </v-card-text>
                <v-card-text>
                  {{ formatDatetimeWithoutTimeZone(item.created_at) }}
                  {{ item.to }}
                </v-card-text>
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-btn
          v-if="callDetail.status == 'Available'"
          :loading="acceptPending"
          @click.native="acceptCall(callDetail.id)"
          color="green"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="acceptButton"
        >
          {{ $vuetify.t('$vuetify.calls.accept') }}
        </v-btn>

        <v-btn
          v-if="callDetail.status == 'Accepted' && !userHasActiveCall"
          :loading="travelPending"
          @click.native="travelCall(callDetail.id)"
          color="orange"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="travelButton"
        >
          {{ $vuetify.t('$vuetify.calls.travel') }}
        </v-btn>

        <v-btn
          v-if="callDetail.status == 'Travelling'"
          :loading="arrivedPending"
          @click.native="checkProximity()"
          :disabled="arrivedPending"
          color="blue"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="arrivedButton"
        >
          {{ $vuetify.t('$vuetify.calls.arrived') }}
        </v-btn>

        <v-btn
          v-if="callDetail.status == 'Arrival Completed'"
          :to="{ name: 'callComplete', params: { id: callDetail.id } }"
          color="green darken-2"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="completeButton"
        >
          {{ $vuetify.t('$vuetify.calls.complete') }}
        </v-btn>

        <v-btn
          v-if="callDetail.status == 'Arrived'"
          @click="arrivalProcessBegin()"
          color="blue darken-2"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="arrivalCompleteButton"
        >
          {{ $vuetify.t('$vuetify.calls.arrivalComplete') }}
        </v-btn>

        <v-btn
          v-if="callDetail.status == 'Departed'"
          :to="{ name: 'callComplete', params: { id: callDetail.id } }"
          color="green darken-2"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="endTravelButton"
        >
          {{ $vuetify.t('$vuetify.calls.complete') }}
        </v-btn>

        <v-btn
          v-if="callDetail.status == 'Accepted' && userHasActiveCall"
          :loading="resetPending"
          @click="dialog = true"
          color="black darken-2"
          large
          fixed
          bottom
          block
          dark
          class="mb-5"
          id="resetButton"
        >
          {{ $vuetify.t('$vuetify.calls.reset') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $vuetify.t('$vuetify.calls.resetCallHeader') }}
        </v-card-title>

        <v-card-text>
          {{ $vuetify.t('$vuetify.calls.resetCallBody') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" flat @click="dialog = false">
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>

          <v-btn color="primary" flat @click="confirmReset">
            {{ $vuetify.t('$vuetify.calls.resetCallConfirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <proximity-dialog
      ref="proximityDialog"
      v-on:accept-proximity-warning="confirmProximity"
      :distance-to-site="this.distanceToSite"
    ></proximity-dialog>

    <contract-notes
      :show="contractNotesDialog"
      :notes="callDetail.contract_note"
      v-on:confirmed="contractNotesConfirmed(callDetail.id)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back="contractNotesDialog = false"
    />

    <sign-in-method
      :show="signInMethodDialog"
      :notes="callDetail.sign_in_method"
      :method="callDetail.sign_in_method"
      :link="callDetail.sign_in_link"
      v-on:confirmed="signInMethodConfirmed(callDetail.id)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(contractNotesDialog = true), (signInMethodDialog = false)"
    />

    <work-assessment
      :show="workAssessmentDialog"
      v-on:confirmed="workAssessmentConfirmed(callDetail.id, ...arguments)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(signInMethodDialog = true), (workAssessmentDialog = false)"
    />

    <pre-work-analysis
      :show="preWorkAnalysisDialog"
      v-on:confirmed="preWorkAnalysisConfirmed(callDetail.id, ...arguments)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back="
        ;(workAssessmentDialog = true), (preWorkAnalysisDialog = false)
      "
    />
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import callActions from '../mixins/callActions.js'
import formatting from '../mixins/formatting.js'
import proximityDialog from '@/components/ProximityDialog.vue'
import ContractNotes from '@/components/arrival/ContractNotes.vue'
import SignInMethod from '@/components/arrival/SignInMethod.vue'
import WorkAssessment from '@/components/arrival/WorkAssessment.vue'
import PreWorkAnalysis from '@/components/arrival/PreWorkAnalysis.vue'
import moment from 'moment'

export default {
  name: 'CallDetail',

  mixins: [callActions, formatting],

  data() {
    return {
      arrivedPending: false,
      travelPending: false,
      acceptPending: false,
      resetPending: false,
      panel: [true, false, false],
      dialog: false,
      destination: {},
      contractNotesDialog: false,
      signInMethodDialog: false,
      workAssessmentDialog: false,
      preWorkAnalysisDialog: false,
      onSiteArrivalProcess: {
        contract_notes_acknowledged_at: null,
        sign_in_confirmed_at: null,
        site_occupied: 0,
        powra_completed: 0,
        asbestos_register_signed: 0,
        asbestos_checkin_completed: 0,
        asbestos_present: 0,
        lone_working_policy: 0,
        work_assessment_escalation_at: null,
        approved_by_name: null,
        approved_by_position: null,
        approved_by_signature_path: null,
        estimated_time_minutes: null,
        estimated_cost_gbp: null
      }
    }
  },

  components: {
    'proximity-dialog': proximityDialog,
    ContractNotes,
    SignInMethod,
    WorkAssessment,
    PreWorkAnalysis
  },

  mounted() {
    //this.readCalls()
    //this.readCall({ id: this.$route.params.id })
  },

  computed: {
    ...mapState({
      calls: state => state.calls.list,
      distanceToSite: state =>
        state.location.distanceToSite &&
        state.location.distanceToSite !== 'undefined'
          ? state.location.distanceToSite.value
          : 0
    }),
    ...mapGetters({
      hasActiveCall: 'calls/hasActiveCall',
      callDetail: 'calls/getActiveCall',
      getCallById: 'calls/getCallById',
      activeCallId: 'calls/activeCallId'
    }),

    callDetail() {
      return this.getCallById(this.$route.params.id)
    },

    timestamps() {
      const timestamps = []
      const call = this.callDetail
      if (!call) {
        return timestamps
      }

      return timestamps
    },

    estimatedDuration() {
      var duration = this.callDetail.estimated_duration_minutes
        ? this.callDetail.estimated_duration_minutes
        : 0

      if (duration == 0) {
        hours = '--'
        minutes = '--'
      } else {
        var hours =
          Math.floor(duration / 60) < 10
            ? '0' + Math.floor(duration / 60)
            : Math.floor(duration / 60)
        var minutes = duration % 60 < 10 ? '0' + (duration % 60) : duration % 60
      }

      return hours + ':' + minutes
    },

    userHasActiveCall() {
      return this.hasActiveCall(this.$route.params.id)
    }
  },

  methods: {
    ...mapActions({
      accept: 'calls/accept',
      travel: 'calls/travel',
      arrived: 'calls/arrived',
      onsiteArrivalProcess: 'calls/onsiteArrivalProcess',
      reset: 'calls/reset',
      readCalls: 'calls/readCalls',
      readCall: 'calls/readCall',
      checkProximity: 'location',
      getETA: 'location/eta'
    }),

    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    acceptCall(callId) {
      this.acceptPending = true
      this._mAcceptCall(callId)
        .then(() => {
          this.acceptPending = false
          this.setNotification(this.$vuetify.t('$vuetify.calls.callAccepted'))
        })
        .catch(() => {
          this.acceptPending = false
          this.setNotification(
            this.$vuetify.t('$vuetify.calls.callNotAccepted')
          )
        })
    },

    travelCall(callId) {
      this.travelPending = true
      this._mTravelCall(callId)
        .then(() => {
          this.travelPending = false
          // this.geoCodeAddress(this.callDetail.postcode)
          this.setNotification(this.$vuetify.t('$vuetify.calls.callTravel'))
          this.$router.push({ name: 'activeCall' })
        })
        .catch(() => {
          this.travelPending = false
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotTravel'))
        })
    },

    arrivalOnsiteProcess(callId = this.callDetail.id) {
      this._mSaveArrivalTime(callId)
      this._mArriveCall(callId).then(() => {
        this.arrivalProcessBegin()
      })
    },

    arrivalProcessBegin() {
      // this.setNotification(this.$vuetify.t('$vuetify.calls.callArrived'))
      if (this.callDetail.contract_note) {
        this.arrivedPending = true
        this.contractNotesDialog = true
        this.arrivedPending = false
      } else {
        this.arrivedPending = true
        this.signInMethodDialog = true
        this.arrivedPending = false
      }
    },

    contractNotesConfirmed() {
      this.contractNotesDialog = false
      this.onSiteArrivalProcess.contract_notes_acknowledged_at = moment().format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.signInMethodDialog = true
    },

    signInMethodConfirmed(callId) {
      this.signInMethodDialog = false
      this.onSiteArrivalProcess.callId = callId
      this.onSiteArrivalProcess.sign_in_confirmed_at = moment().format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.workAssessmentDialog = true
    },

    workAssessmentConfirmed(callId, payload) {
      this.workAssessmentDialog = false
      this.onSiteArrivalProcess.site_occupied = payload.site_occupied
      this.onSiteArrivalProcess.powra_completed = payload.powra_completed
      this.onSiteArrivalProcess.asbestos_register_signed =
        payload.asbestos_register_signed
      this.onSiteArrivalProcess.asbestos_checkin_completed = payload.asbestos_checkin_completed
        ? payload.asbestos_checkin_completed
        : 0
      this.onSiteArrivalProcess.asbestos_present = payload.asbestos_present
        ? payload.asbestos_present
        : 0
      this.onSiteArrivalProcess.lone_working_policy =
        payload.lone_working_policy
      this.onSiteArrivalProcess.work_assessment_escalation_at =
        payload.work_assessment_escalation_at
      this.preWorkAnalysisDialog = true
    },

    preWorkAnalysisConfirmed(callId, payload) {
      this.preWorkAnalysisDialog = false
      this.onSiteArrivalProcess.estimated_time_minutes =
        payload.estimated_time_minutes
      this.onSiteArrivalProcess.estimated_cost_gbp = payload.estimated_cost_gbp
      this.onsiteArrivalProcess(this.onSiteArrivalProcess)
      this.arrivalCompletedCall(callId)
    },

    visitAborted(callId) {
      this.arrivalCompletedCall(callId)
      this.$router.push({ name: 'callComplete', params: { id: callId } })
    },

    arrivalCompletedCall(callId) {
      this.arrivedPending = true
      this._mArrivalCompleted(callId)
        .then(() => {
          this.arrivedPending = false
        })
        .catch(() => {
          this.arrivedPending = false
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotArrived'))
        })
    },

    confirmReset() {
      this.dialog = false
      this._mResetCall(this.callDetail.id)
        .then(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callReset'))
          this.$router.push({ name: 'callsList' })
        })
        .catch(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotReseted'))
        })
    },

    checkProximity(callback = this.arrivalOnsiteProcess) {
      this.fetchLocation()
        .then(pos => {
          pos.routeParams = null
          const origin = new window.google.maps.LatLng(
            pos.coords.latitude,
            pos.coords.longitude
          )

          const destination = new window.google.maps.LatLng(
            this.callDetail.latitude,
            this.callDetail.longitude
          )
          if (this.hasActiveCall()) {
            pos.routeParams = {
              callId: this.activeCallId,
              origin: origin,
              destination: destination
            }
          }
          return pos
        })

        // Record the position
        .then(pos => {
          if (pos.routeParams) {
            this.getETA(pos.routeParams)
              .then(r => {
                if (r.status === 'OK') {
                  pos.coords.distance_to_site = r.distance.value
                  pos.coords.eta = r.duration.value
                  if (r.distance.value > process.env.VUE_APP_PROXIMITY) {
                    this.$refs.proximityDialog.show()
                  } else {
                    callback()
                  }
                }
                this.recordLocation(pos.coords)
                return pos
              })
              .catch(e => {
                this.recordLocation(pos.coords)
                console.error(e)
              })
          }
        })
        .catch(e => {
          console.log('Location Error', e)
          if (e.code == 1) {
            this.setNotification({
              message:
                'You must enable location to use this app, if you denied location service you will need to remove the app from the blacklist. Click the Help link below or contact your controller who will walk you through the process.',
              color: 'error',
              timeout: 20000,
              showHelp: true
            })
          }
          console.error('********************************', e)
        })
    },

    confirmProximity(callback = this.arrivalOnsiteProcess) {
      this.$refs.proximityDialog.hide()
      callback()
    },

    moment: function() {
      return moment()
    },

    callBG: function(type) {
      switch (type) {
        case 'Available':
          return {
            background: 'green lighten-5',
            class: 'black--text ma-2',
            header: 'green lighten-3',
            footer: 'green lighten-3'
          }
        case 'Accepted':
          return {
            background: 'orange lighten-5',
            class: 'black--text ma-2',
            header: 'orange lighten-3',
            footer: 'orange lighten-3'
          }
        case 'Arrived':
          return {
            background: 'blue lighten-5',
            class: 'black--text ma-2',
            header: 'blue lighten-3',
            footer: 'blue lighten-3'
          }
        case 'Completed':
          return {
            background: 'light-blue lighten-5',
            class: 'black--text ma-2',
            header: 'light-blue lighten-3',
            footer: 'light-blue lighten-3'
          }
        case 'Travelling':
          return {
            background: 'indigo lighten-5',
            class: 'black--text ma-2',
            header: 'indigo lighten-3',
            footer: 'indigo lighten-3'
          }
        case 'Canceled':
          return {
            background: 'red lighten-5',
            class: 'black--text ma-2',
            header: 'red lighten-3',
            footer: 'red lighten-3'
          }
        default:
          return {
            background: 'red lighten-5',
            class: 'black--text ma-2',
            header: 'red lighten-3',
            footer: 'red lighten-3'
          }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-btn--bottom:not(.v-btn--absolute) {
  bottom: 0;
  margin-bottom: 36px !important;
  height: 60px;
  font-size: 24px;
}
</style>
